enum ActionType {
    REQUEST_INDICATORS = '[CORE/INDICATORS] GET INDICATORS',
    RECEIVE_INDICATORS = '[CORE/INDICATORS] SET INDICATORS',
}

export default ActionType
